"use client";

import React from "react";
import { Star, Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  id: 1,
  author: "Jane D.",
  role: "Homeowner",
  quote: "Pure Detail Cleaning exceeded my expectations. Highly reliable and thorough. It feels amazing to come home to such a pristine space.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1562197/img/testimonial_homeowner_living_room.png",
  rating: 5
}, {
  id: 2,
  author: "John S.",
  role: "Realtor",
  quote: "Their move-in/move-out service is top-notch. Perfect for my listings. I can always count on them to make a property shine before a showing.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1562197/img/testimonial_realtor_handshake.png",
  rating: 5
}, {
  id: 3,
  author: "Sarah M.",
  role: "Short-Term Rental Host",
  quote: "Pure Detail makes my turnovers seamless. 5-star cleanliness every time, which translates directly to better reviews for my rental.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1562197/img/testimonial_rental_bedroom.png",
  rating: 5
}];
export default function CustomerTestimonialsSlider() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="customer-testimonials-slider" className="w-full bg-secondary py-24 md:py-32 overflow-hidden" ref={ref}>
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className={`mb-16 transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <h2 className="text-primary font-sans font-extrabold text-4xl md:text-5xl tracking-tighter mb-4">
            Client Experiences
          </h2>
          <p className="font-serif italic text-foreground/80 text-xl">
            Pure Effort. Pure Pride. Pure Detail.
          </p>
        </div>

        <Carousel opts={{
        align: "start",
        loop: true
      }} className="w-full">
          <CarouselContent className="-ml-4">
            {testimonials.map((testimonial, i) => <CarouselItem key={testimonial.id} className="pl-4 basis-full md:basis-1/2 lg:basis-1/3">
                <div data-index={i} className="bg-background p-8 md:p-10 h-full flex flex-col justify-between shadow-sm border-t-4 border-primary">
                  <div>
                    <div className="flex gap-1 mb-6">
                      {Array.from({
                    length: testimonial.rating
                  }).map((_, starIndex) => <Star key={starIndex} className="w-4 h-4 fill-primary text-primary" />)}
                    </div>

                    <Quote className="w-8 h-8 text-primary/20 mb-6" />

                    <blockquote className="font-serif italic text-xl md:text-2xl leading-relaxed text-foreground mb-8">
                      &ldquo;{testimonial.quote}&rdquo;
                    </blockquote>
                  </div>

                  <div className="flex items-center gap-4 pt-6 border-t border-border/50">
                    <div className="w-12 h-12 overflow-hidden shrink-0">
                      <img src={testimonial.image} data-wvc-srcset={`${testimonial.image}-wvc-srcset`} data-wvc-sizes={`${testimonial.image}-wvc-sizes`} alt={testimonial.author} className="w-full h-full object-cover" loading="lazy" />
                    </div>
                    <div className="flex flex-col">
                      <cite className="not-italic font-sans font-bold text-sm tracking-wider text-primary uppercase">
                        {testimonial.author}
                      </cite>
                      <span className="text-foreground/60 text-xs font-medium tracking-widest uppercase">
                        {testimonial.role}
                      </span>
                    </div>
                  </div>
                </div>
              </CarouselItem>)}
          </CarouselContent>

          <div className="flex justify-end gap-2 mt-12">
            <CarouselPrevious variant="default" className="static translate-y-0 translate-x-0 h-12 w-12 rounded-none bg-primary text-primary-foreground border-none hover:bg-primary/90 transition-all" />
            <CarouselNext variant="default" className="static translate-y-0 translate-x-0 h-12 w-12 rounded-none bg-primary text-primary-foreground border-none hover:bg-primary/90 transition-all" />
          </div>
        </Carousel>
      </div>
    </section>;
}